export const getTreeKeysSelected = selectedObject => {
  const response = [];
  [
    ...Object.entries(selectedObject)
      .map(([key, values]) =>
        [...(values || [])].map(value => `${key}_${value}`)
      )
      .filter(array => array.length !== 0),
  ].forEach(values => values.forEach(value => response.push(value)));
  return response;
};

export const getNonEnforcementReasonsCodesFromNormalizedNames = (
  normalizedNames,
  groupedNonEnforcementReasons
) => {
  if (!Array.isArray(normalizedNames)) {
    return [];
  }

  return normalizedNames
    .map(normalizedName => {
      const reasonsGroup =
        groupedNonEnforcementReasons[normalizedName]?.reasons;

      return Array.isArray(reasonsGroup)
        ? reasonsGroup.map(({ code }) => code)
        : [];
    })
    .flat();
};
